import { TxnDetailWrapperProps } from '@bitte-ai/types';
import { TxnActionsDetails } from './TxnActionsDetails';

export const TxnDetail = ({
  accountId,
  transaction,
  modifiedUrl,
  showDetails,
  showTxnDetail,
  costs,
  gasPrice,
}: TxnDetailWrapperProps): JSX.Element => {
  return (
    <TxnActionsDetails
      accountId={accountId}
      costs={costs}
      gasPrice={gasPrice}
      transaction={transaction}
      modifiedUrl={modifiedUrl}
      showDetails={showDetails}
      showTxnDetail={showTxnDetail}
    />
  );
};
